import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/proposals/iterator-helpers';

import * as React                      from 'react';
import ReactOnRails                    from 'react-on-rails';
import { Provider }                    from 'react-redux';
import { BrowserRouter, StaticRouter } from 'react-router-dom';

import 'swiper/swiper-bundle.css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import i18nextInit from '../common/services/i18n';

import { configureStore } from './common/store';

import '../common/tools/extentions';

import './assets/scss/components/accordion.scss';
import './assets/scss/components/alert.scss';
import './assets/scss/components/article.scss';
import './assets/scss/components/backdrop.scss';
import './assets/scss/components/bookmarksModal.scss';
import './assets/scss/components/button.scss';
import './assets/scss/components/callMeForm.scss';
import './assets/scss/components/card.scss';

import './assets/scss/components/catalog/collapsible.scss';
import './assets/scss/components/catalog/offersSlider.scss';
import './assets/scss/components/catalog/priceBlock.scss';
import './assets/scss/components/catalog/comparePrice.scss';
import './assets/scss/components/catalog/grid.scss';
import './assets/scss/components/catalog/filter.scss';
import './assets/scss/components/catalog/popularSlider.scss';

import './assets/scss/components/category.scss';
import './assets/scss/components/citiesBlock.scss';
import './assets/scss/components/collapseBlock.scss';
import './assets/scss/components/consultation.scss';
import './assets/scss/components/compareModal.scss';
import './assets/scss/components/counter.scss';
import './assets/scss/components/dealerRequestModal.scss';
import './assets/scss/components/downloadableCard.scss';
import './assets/scss/components/dropdown.scss';
import './assets/scss/components/dropzone.scss';

import './assets/scss/components/fields/checkboxButtons.scss';
import './assets/scss/components/fields/dropZone.scss';
import './assets/scss/components/fields/input.scss';
import './assets/scss/components/fields/rangeSlider.scss';
import './assets/scss/components/fields/select.scss';

import './assets/scss/components/footer.scss';
import './assets/scss/components/frontPageFooter.scss';
import './assets/scss/components/grid.scss';

import './assets/scss/components/information/sidebar.scss';
import './assets/scss/components/information/body.scss';

import './assets/scss/components/lightBox.scss';
import './assets/scss/components/modal.scss';
import './assets/scss/components/moreInfoModal.scss';
import './assets/scss/components/notificationModal.scss';
import './assets/scss/components/orderModal.scss';
import './assets/scss/components/pageHeader.scss';
import './assets/scss/components/popover.scss';
import './assets/scss/components/preloader.scss';
import './assets/scss/components/rating.scss';
import './assets/scss/components/review.scss';
import './assets/scss/components/search.scss';
import './assets/scss/components/share.scss';
import './assets/scss/components/sidebar.scss';
import './assets/scss/components/table.scss';
import './assets/scss/components/tabs.scss';
import './assets/scss/components/userLocation.scss';
import './assets/scss/components/icons.scss';
import './assets/scss/components/marquiz.scss';

import './assets/scss/pages/aboutDoors.scss';
import './assets/scss/pages/catalog.scss';
import './assets/scss/pages/constructor.scss';
import './assets/scss/pages/contacts.scss';
import './assets/scss/pages/frontPage.scss';
import './assets/scss/pages/guarantee.scss';
import './assets/scss/pages/information.scss';
import './assets/scss/pages/productCard.scss';
import './assets/scss/pages/profile.scss';
import './assets/scss/pages/whereBuy.scss';
import './assets/scss/pages/news.scss';
import './assets/scss/pages/reviews.scss';
import './assets/scss/pages/agreement.scss';
import './assets/scss/pages/verification.scss';
import './assets/scss/pages/sitemap.scss';
import './assets/scss/pages/promotions.scss';

import './assets/scss/style.scss';
import './assets/scss/_fontface.scss';

import Wrapper     from './Wrapper';
import AppProvider from './providers/app/app.provider';

import './assets/images/favicon-16x16.png';
import './assets/images/favicon-32x32.png';
import './assets/images/favicon-120x120.png';
import './assets/images/favicon-128x128.png';

// On the server translations are in memory before the bundle runs; in the browser they arrive
// asynchronously from /api/translations (even the localStorage cache is read asynchronously).
// Hydrating before they arrive renders translation keys instead of texts, the markup no longer
// matches the server HTML, and React 18 throws that HTML away and re-renders the whole root
// (errors #418/#423). Suspending inside a Suspense boundary makes React keep the server HTML
// untouched until the translations are ready and only then hydrate against it. The promise is
// made to always resolve, so a failed translations request cannot leave the boundary suspended.
let translationsReady = isSSR();
const translationsPromise = i18nextInit()
  .catch(() => {})
  .then(() => {
    translationsReady = true;
  });

const TranslationsGate = function({ children }) {
  if (!translationsReady) {
    throw translationsPromise;
  }

  return children;
};

const App = (props, context) => {
  const {
          base,
          location,
          serverSide,
        }     = context;
  const store = ReactOnRails.getStore('SteellineStore');

  if (serverSide) {
    return (
      <Provider store={store}>
        <StaticRouter basename={base} location={location} context={{}}>
          <AppProvider value={props}>
            <React.Suspense fallback={null}>
              <TranslationsGate>
                <Wrapper />
              </TranslationsGate>
            </React.Suspense>
          </AppProvider>
        </StaticRouter>
      </Provider>
    );
  }

  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppProvider value={props}>
          <React.Suspense fallback={null}>
            <TranslationsGate>
              <Wrapper />
            </TranslationsGate>
          </React.Suspense>
        </AppProvider>
      </BrowserRouter>
    </Provider>
  );
};

ReactOnRails.registerStore({ SteellineStore: configureStore });
ReactOnRails.register({
  App: (props, context) => App.bind(null, props, context),
});